<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FornecedorModule',
  }
</script>
